// extracted by mini-css-extract-plugin
module.exports = {"featured__container":"_2mUx3hbpgBATZmbs_oG8bu","contactBanner":"_1qt4tQWnrFE084Ffv6m2Oe"};